export default __webpack_public_path__ + "static/media/group-8393.550ac2ee.png";